<template>
    <!--弹窗-->
    <el-dialog
        width="680px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="140px"
        >
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="formData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/etyma/etyma";
export default {
    data() {
        return {
            loading: false,
            dateArr: [],
            rules: {
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ]
            },
            arrExclude_activity: [],
            formData: {
                dateArr: [],
            }
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
		infoData: {
			type: Object,
			default: () => {}
		},
    },
	mounted(){
	},
    methods: {
        typeNumber(str) {
            return Number(Number(str));
            // return Number(Number(str).toFixed(2));
        },
        // 保存信息
        submitForm() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    let formData = this.formData;
					console.log(formData)
                    let obj = {
						start_date: this.formData.dateArr[0],
						end_date: this.formData.dateArr[1],
						state: this.infoData.state,
                        parent_asin: this.infoData.parent_asin,
                    };
                    this.loading = true;
                    // return
                    api.out_three_page_add(obj)
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                this.$emit("refresh");
                                this.handleClose(false);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message: "网络出现问题，请刷新页面！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        onArrExclude_activity(arr) {
            this.arrExclude_activity = arr;
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {
                clicks: 20,
                tower_acos: 0.9,
                high_click_not_order: 0.8,
                low_click_not_order: 0.95
            };
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
	.acos{
		margin-left: -155px;
		.acosItem{
			float: left;
			width:300px;
			text-align: right;
		}
	}
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;
	
    .shu {
        border-right: 1px solid #cecfd1;
    }
    .content-div {
        width: 50%;
        padding: 25px 20px;
    }
    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }
    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;
        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }
    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
